import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { CondominiumShowPage } from './condominium-show';
import { ComponentsModule } from '../../components/components.module';

@NgModule({
	declarations: [
		CondominiumShowPage,
	],
	imports: [
		ComponentsModule,
		IonicPageModule.forChild(CondominiumShowPage),
	],
})
export class CondominiumShowPageModule {}



// WEBPACK FOOTER //
// ./src/pages/condominium-show/condominium-show.module.ts